const JWT_SECTIONS = 3;

/**
 * Extranct scope from jwt token
 * @param {String} token
 * @return {Boolean}
 */
export default function authenticate(token) {
    try {
        var sections = token.split(".");
        
        if (sections.length != JWT_SECTIONS) {
            throw new Error("malformed jwt")
        }
    
        var payload = JSON.parse(Buffer.from(sections[1], "base64").toString());
    
        var keys = Object.keys(payload);
    
        if (!keys.includes("exp")) {
            throw new Error("token expiry is not set")
        }
    
        var expiry = payload["exp"];
        var now = Math.floor(Date.now() / 1000);
    
        if(now >= expiry) {
            return false;
        }
    
        return true;

    } catch {

        return false;
        
    }
} 